const _helper = {
    rules: {
        /**
         * 如果必填项验证希望能够显示自定义的错误消息，那么可以调用这个函数来生成一个箭头函数
         * @param {string} msg 要显示的错误消息
         * @returns Function
         */
        genRequired: function(msg) {
            return v => (!!v && v.trim().length > 0) || msg;
        },

        required: v => {
            return (!!v && ((typeof v === 'string' && v.trim().length > 0) || (typeof v === 'object'))) || '必填项，请输入';
        },

        redeemCode: v => /^[A-Za-z0-9]{8}$/.test(v) || '包含数字 0-9，字母 A-Z，不区分大小写',

        phoneNumber: v => {
            if (!v) return '请输入手机号';
            if (!/^1\d{10}$/.test(v)) return '手机号格式错误';

            return true;
        },

        password: v => {
            if (! v) return '请输入密码';
            if (v.length < 8 || v.length > 16) return '密码格式错误';

            if (!/^(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).{8,16}$/g.test(v)) return '密码格式错误';
            else return true;
        },

        verificationCode: v => {
            if (!v) return '请输入验证码';
            return /^\d{4}$/.test(v) || '验证码格式错误';
        },

        numberRequired: n => (n != null && typeof n != 'undefined' && ! isNaN(n)) || '请输入有效的数值',

        numberRange: function(minVal, maxVal, msg) {
            const retMsg = msg === undefined ? '无效的数值' : msg;
            return v => {
                if (v === null || v === undefined) return retMsg;

                if (typeof v === 'string' && v.trim().length === 0) return retMsg;

                if (isNaN(v)) return retMsg;

                const nv = +v;
                if (nv < minVal || nv > maxVal) return retMsg;

                return true;
            };
        },

        positiveInteger: function(val, msg) {
            if (!(/(^[1-9]\d*$)/.test(val))) {
                return msg || '无效的数值';
            }
            return true;
        },
    },

    checkPhoneNumber: function (v) {
        if (!v) return false;
        return /^1\d{10}$/.test(v);
    },

    /**
     * Generate a random key
     * @returns {string}
     */
    randomId: function() {
        return `rk-${Math.random().toString(16).substring(2)}`;
    },

    /**
     * Split string to lines
     * @param s Array of strings
     */
    stringToLines: function(s) {
        if (s == null || s == undefined) return [];
        return s.split('\n');
    },

    /**
     * 将秒为单位的数值转换成 m:s 的时长格式
     * @param s
     */
    secondsToDuration: function(s) {
        let n = parseInt(s);
        if (isNaN(n)) return '-';
        if (n < 10) return `0:0${n}`;
        if (n < 60) return `0:${n}`;

        let m = Math.floor( n / 60);
        let d = n - m * 60;
        if (d < 10) return `${m}:0${d}`;
        return `${m}:${d}`;
    },

    /**
     * 将以分为单位的整数转换成以元为单位的字符串
     * @param fen number
     * @param withCommas boolean 默认是为返回的数值增加千分符的，如果不需要千分符，把这个参数设置为 false 即可
     * @returns string 转换到元为单位的字符串表示
     */
    fen2YuanString: function(fen, withCommas) {
        const sign = fen < 0 ? '-' : '';
        const fenAbs = parseInt(Math.abs(fen));
        if (fenAbs < 10) return `${sign}0.0${fen}`;
        if (fenAbs < 100) return `${sign}0.${fen}`;

        const s = `${fenAbs}`;
        const ret = `${sign}${s.substring(0, s.length - 2)}.${s.substring(s.length - 2)}`;
        if (typeof withCommas === 'boolean' && !withCommas) {
            return ret;
        } else {
            return this.numberWithCommas(ret);
        }
    },

    /**
     * 将以分为单位的整数转换成蓝豆数量,是一个千分位字符串，仅做显示，不可以做计算
     * @param fen
     * @param withCommas
     */
    fen2BlueBeanString: function(fen, withCommas) {
        // 蓝豆要向下取整，因为实际交易会让利给用户，分会被舍去
        const n = Math.floor((parseInt(fen) / 10));
        if (typeof withCommas === 'boolean' && !withCommas) {
            return `${n}`;
        } else {
            return this.numberWithCommas(n);
        }
    },


    numberWithCommas: function(x) {
        const parts = x.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    },

    /**
     * 将以分为单位的整数转换成蓝豆数量，可以作计算
     * @param fen
     * @param withCommas
     * @returns {number}
     */
    fen2BlueBeanNumber: function(fen) {
        return Math.floor(parseInt(fen) / 10);
    },

    /**
     * Test if a string is blank or not.
     * Not blank string is not null, not undefined and contains at lease 1 no-space character
     * @param {string | null | undefined} s
     */
    isBlank: function(s) {
        return s === null || s === undefined || s.trim().length === 0;
    },

    /**
     * Test if a string is a valid phone number or not
     *
     * @param s
     */
    isPhoneNumber: function(s) {
        return s !== null && s !== undefined && /^1\d{10}$/.test(s);
    },

    /**
     * Truncate the text to given length
     * @param s
     * @param maxLength
     */
    truncateText: function(s, maxLength) {
        if (s === null || s === undefined || s.length < maxLength) return s;
        return s.substring(0, maxLength);
    },

    postMessage: function(msg) {
        window.postMessage(msg, window.location.origin);
    },

    /**
     * The default footer props for v-data-table
     *
     * @return     {Object}
     */
    defaultFooterProps: function() {
        return {
            itemsPerPageOptions: [10, 20, 50, 100],
        };
    },

    /**
     * default options for v-data-table
     */
    defaultOptions: function() {
        return {
            page: 1,
            itemsPerPage: 20,
        };
    },
};


export default _helper;